var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.52 58.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a7dce;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.26,
    cy: 29.26,
    r: 29.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.61,40.65c.16-.67.3-1.26.45-1.85q.89-3.59,1.79-7.17c.13-.54.22-.62.79-.68l8.81-1,.41,0a.67.67,0,0,0,.63-.67.66.66,0,0,0-.63-.64l-3.41-.38-6-.66a.6.6,0,0,1-.56-.54q-1-3.91-2-7.82a9.69,9.69,0,0,1-.23-1,1.37,1.37,0,0,1,.56-1.44,1.41,1.41,0,0,1,1.55-.09L31,22.09,42.2,27.56a1.85,1.85,0,0,1,.42,3.14,2.48,2.48,0,0,1-.49.3L19.88,41.85a1.39,1.39,0,0,1-1.9-.34A4.55,4.55,0,0,1,17.61,40.65Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.ef7e386f06f20ebc532894796e7ac377.svg";
export { ForwardRef as ReactComponent };